module.exports = __webpack_public_path__ + "img/1568913110.f8d065c4.jpg";